/* Reuses the self-hosted MapLibre bundle and approved OpenFreeMap Positron style. */
(() => {
  if (customElements.get('rymar-location-map')) return;
  let library;
  const loadLibrary = (url, stylesheet) => {
    if (window.maplibregl) return Promise.resolve(window.maplibregl);
    if (!library) library = new Promise((resolve, reject) => {
      const css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = stylesheet;
      const ready = new Promise((done) => { css.onload = done; css.onerror = done; });
      document.head.append(css);
      const script = document.createElement('script');
      script.src = url;
      script.onload = () => ready.then(() => resolve(window.maplibregl));
      script.onerror = () => { library = null; script.remove(); reject(new Error('Map unavailable')); };
      document.head.append(script);
    });
    return library;
  };
  customElements.define('rymar-location-map', class extends HTMLElement {
    connectedCallback() {
      if (this.observer || this.pending || this.map) return;
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.observer.disconnect(); this.start();
        }
      }, { rootMargin: '200px' });
      this.observer.observe(this);
    }
    async start() {
      const lat = Number(this.dataset.latitude), lon = Number(this.dataset.longitude);
      if (!this.dataset.latitude?.trim() || !this.dataset.longitude?.trim() ||
        !Number.isFinite(lat) || !Number.isFinite(lon) || Math.abs(lat) > 90 || Math.abs(lon) > 180) return;
      const token = this.pending = {};
      const canvas = this.querySelector('[data-map]');
      const status = this.querySelector('[data-map-status]');
      try {
        const gl = await loadLibrary(this.dataset.library, this.dataset.stylesheet);
        if (!this.isConnected || this.pending !== token) return;
        canvas.hidden = false;
        const map = this.map = new gl.Map({
          container: canvas, style: 'https://tiles.openfreemap.org/styles/positron',
          center: [lon, lat], zoom: 11, maxZoom: 18, minZoom: 1,
          scrollZoom: false, cooperativeGestures: true, dragRotate: false,
          pitchWithRotate: false, touchPitch: false, renderWorldCopies: false,
          attributionControl: false,
        });
        window.RymarMapStyle?.attach(map);
        map.touchZoomRotate.disableRotation();
        map.addControl(new gl.NavigationControl({ showCompass: false }), 'bottom-right');
        map.addControl(new gl.AttributionControl({ compact: false }), 'bottom-left');
        const marker = document.createElement('button');
        marker.className = 'rymar-location__marker rymar-map-marker';
        marker.type = 'button';
        marker.setAttribute('aria-label', this.dataset.name);
        const callout = this.querySelector('[data-map-callout]');
        if (callout) {
          callout.hidden = true;
          marker.setAttribute('aria-controls', callout.id);
          marker.setAttribute('aria-expanded', 'false');
          this.events = new AbortController();
          const options = { signal: this.events.signal };
          let closing = false;
          const open = () => {
            if (closing) return;
            callout.hidden = false;
            marker.setAttribute('aria-expanded', 'true');
          };
          const close = () => {
            callout.hidden = true;
            marker.setAttribute('aria-expanded', 'false');
            closing = true; marker.focus({ preventScroll: true }); closing = false;
          };
          marker.addEventListener('click', open, options);
          marker.addEventListener('focus', open, options);
          callout.querySelector('[data-close-callout]').addEventListener('click', close, options);
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && !callout.hidden) { event.preventDefault(); event.stopPropagation(); close(); }
          }, options);
        } else {
          marker.disabled = true;
        }
        this.marker = new gl.Marker({ element: marker }).setLngLat([lon, lat]).addTo(map);
        this.resize = new ResizeObserver(() => map.resize());
        this.resize.observe(canvas);
        const fail = () => {
          canvas.hidden = true;
          if (callout) callout.hidden = true;
          this.events?.abort();
          status.hidden = false;
          status.textContent = 'Map unavailable. Use the location details or Get Directions link.';
          this.resize?.disconnect();
          this.marker?.remove();
          map.remove();
          this.map = null;
        };
        this.timer = setTimeout(fail, 15000);
        map.once('load', () => { clearTimeout(this.timer); status.hidden = true; });
        map.on('error', () => {
          // Keep directions available for transient tile errors; timeout handles total failure.
          status.hidden = false;
          status.textContent = 'Some map details could not load. Get Directions remains available.';
        });
      } catch {
        if (this.isConnected && this.pending === token) {
          canvas.hidden = true;
          status.hidden = false;
          status.textContent = 'Map unavailable. Use the location details or Get Directions link.';
        }
      } finally { if (this.pending === token) this.pending = null; }
    }
    disconnectedCallback() {
      this.pending = null;
      this.events?.abort();
      const callout = this.querySelector('[data-map-callout]');
      if (callout) callout.hidden = true;
      clearTimeout(this.timer);
      this.observer?.disconnect(); this.observer = null;
      this.resize?.disconnect();
      this.marker?.remove();
      this.map?.remove(); this.map = null;
    }
  });
})();
